import React, { useState } from 'react'

function UseGet() {
    const [score,setScore] = useState();
    const {usename,setUsername} = useState([])

    const GetScore = async (token)=>{
        try{

            const response = await fetch('https://djangoapp.arifsultani291.digital/score/',{
                method:'POST',
                headers:{'Content-Type':'application/json'},
                body:JSON.stringify({
                    token:token
                })
            })

        if(response.ok){
            const jsonData = await response.json();
            setScore(jsonData.data.score.score)
            console.log(jsonData.data.username.username)
            setUsername(jsonData.data.username.username)

        }else{
            const jsonData = await response.json();
            console.log(jsonData)
            setScore(jsonData)
        }

        }catch(error){

        }
        
    }

  return {GetScore,score,usename}
}

export default UseGet
